import { Graphics } from './graphics'
import { LineStyle, LIGHT_BLUE_LINE, BLUE_LINE, WHITE_LINE, LIGHT_WHITE_LINE } from './lines'
import { Point } from '../math/point'
import { WorldGrid } from '../model/world-grid'
import { range } from '../math/util'

export class GridDisplay {
  constructor(readonly graphics: Graphics) { }

  protected _drawInnerGrid(grid: WorldGrid) {
    this.graphics.lineStyle(LIGHT_BLUE_LINE)
    this.graphics.relative = true
    // half size of entire grid in world coordinates
    const halfGridLength = grid.length / 2
    const xs = range(grid.squares+1).map(i => i * grid.step)

    for (const x of xs) {
      const x0 = x - halfGridLength + Math.floor(grid.origin.x / grid.step) * grid.step
      this.graphics.line(new Point(x0, halfGridLength+grid.origin.y), new Point(x0, -halfGridLength+grid.origin.y))
    }

    for (const y of xs) {
      const y0 = y - halfGridLength  + Math.floor(grid.origin.y / grid.step) * grid.step
      this.graphics.line(new Point(-halfGridLength+grid.origin.x, y0), new Point(halfGridLength+grid.origin.x, y0))
    }
  }

  protected _drawAxisGrid(grid: WorldGrid) {
    this.graphics.lineStyle(LIGHT_WHITE_LINE)
    this.graphics.relative = false
    // half size of entire grid in world coordinates
    const halfGridLength = grid.length / 2
    const stepLength = grid.step / 2
    const xs = range(grid.squares).map(i => i * grid.step)

    this.graphics.line(new Point(-halfGridLength, 5), new Point(halfGridLength, 5))
    this.graphics.line(new Point(-halfGridLength, -5), new Point(halfGridLength, -5))

    this.graphics.line(new Point(5, halfGridLength), new Point(5, -halfGridLength))
    this.graphics.line(new Point(-5, halfGridLength), new Point(-5, -halfGridLength))

    for (const x of xs) {
      const x0 = x - halfGridLength + grid.step
      this.graphics.line(new Point(x0, stepLength), new Point(x0, -stepLength))
    }

    for (const y of xs) {
      const y0 = y - halfGridLength  +  grid.step
      this.graphics.line(new Point(-stepLength, y0), new Point(stepLength, y0))
    }
  }

  drawGrid(grid: WorldGrid) {
    this._drawInnerGrid(grid)
    // this._drawAxisGrid(grid)

    this.graphics.relative = false
    const halfGridLength = grid.length / 2
    this.graphics.lineStyle(BLUE_LINE)
    this.graphics.line(new Point(-halfGridLength, -halfGridLength), new Point(-halfGridLength, halfGridLength))
    this.graphics.line(new Point(halfGridLength, -halfGridLength), new Point(halfGridLength, halfGridLength))

    this.graphics.line(new Point(-halfGridLength, -halfGridLength), new Point(halfGridLength, -halfGridLength))
    this.graphics.line(new Point(-halfGridLength, halfGridLength), new Point(halfGridLength, halfGridLength))

    this.graphics.relative = true
  }
}